import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-vehicle-inspection-modal',
  templateUrl: './vehicle-inspection-modal.component.html',
  styleUrls: ['./vehicle-inspection-modal.component.scss']
})
export class VehicleInspectionModalComponent implements OnInit {

  inspectionId: string = '';
  inspectionItemId: string = '';
  associatedInspectionId;
  estimateId: string = '';
  isReadOnly: boolean = false;
  customer;
  service;
  isSidePanelOnly: boolean = false;
  isFinalized = false
  currentLang: string = 'en';

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef
  ) {
  }

  ngOnInit(): void {
    const { inspectionId, inspectionItemId, estimateId, customer, service, isReadonly, isSidePanelOnly, isFinalized, currentLang, associatedInspectionId } = this.dialogConfig.data;
    this.inspectionId = inspectionId;
    this.associatedInspectionId = associatedInspectionId;
    this.isFinalized = isFinalized;
    this.estimateId = estimateId;
    this.customer = customer;
    this.service = service;
    this.inspectionItemId = inspectionItemId;
    this.isSidePanelOnly = isSidePanelOnly;
    this.currentLang = currentLang;
    this.isReadOnly = isReadonly;
  }

  handleClose(event) {
    this.dynamicDialogRef.close(event);
  }
}
